/**
 * Every dialog the UA Insights feature can mount. The active dialog is tracked
 * via the `dialog` URL search param so dialogs are deep-linkable, refresh-safe,
 * and back/forward-friendly.
 *
 * Declared as a runtime array (rather than a bare type union) so the value
 * read back out of the URL can be validated against it — the param is
 * user-editable and must not be trusted to hold a member of the union.
 */
export const UA_INSIGHTS_DIALOG_TYPES = [
  'tag',
  'ad',
  'genre-tags',
  'motivation',
  'tag-games',
  'dimension-tags',
  'all-creatives',
  'all-games',
  'all-tags',
  'compare-game',
  'blind-spot',
  'alignment',
  'shared-motivation',
  'diverging-motivation',
] as const

export type UAInsightsDialogType = (typeof UA_INSIGHTS_DIALOG_TYPES)[number]
